const PRICES_PER_COUNTRY = {
	DEFAULT: {
		teacher: 7.95,
		teacher_year_overwrite: 95,
		school: 42,
		school_year_overwrite: 495,
		school_unlimited: 83,
		school_unlimited_year_overwrite: 995,
		label: '$ {price}',
		currency: 'USD',
		BCP47: 'en-US',
	},
	AU: {
		teacher: 11.95,
		school: 99,
		label: 'AU$ {price}',
		currency: 'AUD',
		BCP47: 'en-AU',
	},
	CA: {
		teacher: 10.95,
		school: 89,
		label: 'CAD$ {price}',
		currency: 'CAD',
		BCP47: 'en-CA',
	},
	CH: {
		teacher: 11.95,
		school: 49,
		label: 'CHF {price}',
		currency: 'CHF',
		BCP47: 'de-CH',
	},
	DK: {
		teacher: 59,
		school: 499,
		label: 'DKK {price}',
		currency: 'DKK',
		BCP47: 'da-DK',
	},
	IT: {
		teacher: 6.95,
		school: 35,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'it-IT',
	},
	FR: {
		teacher: 6.95,
		school: 25,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'fr-FR',
	},
	// BE: {
	// 	teacher: 6.95,
	// 	school: 25,
	// 	label: '€ {price}',
	// 	currency: 'EUR',
	// },
	ES: {
		teacher: 6.95,
		school: 49,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'es-ES',
	},
	AT: {
		teacher: 6.95,
		school: 29,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'de-AT',
	},
	IE: {
		teacher: 6.95,
		school: 35,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'en-IE',
	},
	DE: {
		teacher: 6.95,
		school: 39,
		label: '€ {price}',
		currency: 'EUR',
		BCP47: 'de-DE',
	},
	GB: {
		teacher: 5.95,
		school: 29,
		label: '£{price}',
		currency: 'GBP',
		BCP47: 'en-GB',
	},
	MX: {
		teacher: 69,
		school: 129,
		label: '$ {price} MXN',
		currency: 'MXN',
		BCP47: 'es-MX',
	},
	NO: {
		teacher: 89,
		school: 799,
		label: 'NOK {price}',
		currency: 'NOK',
		BCP47: 'nb-NO',
	},
	SE: {
		teacher: 79,
		school: 649,
		label: 'SEK {price}',
		currency: 'SEK',
		BCP47: 'sv-SE',
	},
};

export function getCountryBasedCurrency(country) {
	const countryBasedPrices = PRICES_PER_COUNTRY[country] || PRICES_PER_COUNTRY.DEFAULT;
	return countryBasedPrices.currency;
}

export function getCountryBasedPrice(country, amount, type, annual) {
	const countryBasedPrices = PRICES_PER_COUNTRY[country] || PRICES_PER_COUNTRY.DEFAULT;
	const pricePerMonth = (countryBasedPrices[type] ?? countryBasedPrices.teacher) * amount;

	let price = pricePerMonth;
	if (annual) {
		const yearOverwrite = countryBasedPrices[`${type}_year_overwrite`];
		if (yearOverwrite) {
			price = yearOverwrite * amount;
		} else {
			price *= 12;
		}
	}

	return parseFloat(price).toFixed(2);
}

export function getCountryBasedPriceLabel(country, amount, type, annual) {
	const countryBasedPrices = PRICES_PER_COUNTRY[country] || PRICES_PER_COUNTRY.DEFAULT;
	const price = getCountryBasedPrice(country, amount, type, annual);

	const parts = new Intl.NumberFormat(countryBasedPrices.BCP47).formatToParts(price);
	const priceLabel = parts.reduce((prev, curr) => {
		if (curr.type === 'fraction') {
			// add a trailing 0
			if (parseInt(curr.value, 10) < 10) {
				return `${prev}${curr.value}0`;
			}
			return `${prev}${curr.value}`;
		}
		return `${prev}${curr.value}`;
	}, '');

	return countryBasedPrices.label.replace('{price}', priceLabel);
}
